'use strict';

exports.__esModule = true;
var ASSISTANT = exports.ASSISTANT = {
  FETCH_ASSISTANTS: {
    LOAD: 'ASSISTANTS_FETCH',
    SUCCESS: 'ASSISTANTS_FETCH_SUCCESS',
    FAIL: 'ASSISTANTS_FETCH_FAIL'
  },
  ASSISTANT_STATE: {
    LOAD: 'ASSISTANT_STATE_LOAD',
    SUCCESS: 'ASSISTANT_STATE_SUCCESS',
    FAIL: 'ASSISTANT_STATE_FAIL'
  },
  ADD_ASSISTANT: {
    LOAD: 'ASSISTANT_ADD_LOAD',
    SUCCESS: 'ASSISTANT_ADD_SUCCESS',
    FAIL: 'ASSISTANT_ADD_FAIL'
  },
  MODAL: {
    TOGGLE_ADD: 'ADD_MODAL'
  }
};

var getAssistants = exports.getAssistants = function getAssistants(entityKey) {
  return {
    type: ASSISTANT.FETCH_ASSISTANTS.LOAD,
    entityKey: entityKey
  };
};

var addAssistant = exports.addAssistant = function addAssistant(entityKey, assistantDetails) {
  return {
    type: ASSISTANT.ADD_ASSISTANT.LOAD,
    assistantDetails: assistantDetails,
    entityKey: entityKey
  };
};

var toggleAssistantState = exports.toggleAssistantState = function toggleAssistantState(state) {
  return {
    type: ASSISTANT.ASSISTANT_STATE.LOAD,
    state: state
  };
};

var toggleAddAssistanthModal = exports.toggleAddAssistanthModal = function toggleAddAssistanthModal(showModel) {
  return {
    type: ASSISTANT.MODAL.TOGGLE_ADD,
    showModel: showModel
  };
};